import { createContext } from 'react';

export const BackdropContext = createContext<(open: boolean, key: string) => void>(null!);